var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.part),function(el,index){return _c('the-welfare-part',{key:index,attrs:{"data":_vm.part[index],"active":_vm.partActive},on:{"tap":_vm.handleTap}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }